export default __webpack_public_path__ + "static/media/ecoclyb.2a48d9a1.png";